import MuiModal from './MuiModal';

export default MuiModal;
